import React from "react";
import { useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Typography,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
  },
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  spaceAfter: {
    marginBottom: 15,
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

export const EmailInUse = () => {
  const classes = useStyles();
  const location = useLocation();
  const email = location.state && location.state.email;

  return (
    <Box className={classes.root} component="main">
      <CssBaseline />
      <Container maxWidth="xs">
        <div className={classes.content}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" className={classes.spaceAfter}>
            An account already exists
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {email
              ? `An account for ${email} already exists on PlanPraise.`
              : "An account with this email already exists on PlanPraise."}
          </Typography>
          <Typography variant="body1" color="textSecondary" className={classes.spaceAfter}>
            For your security, we can't automatically connect this sign-in method
            to it. If you can still sign in with your original method, do that
            and add this one from Account Settings. Otherwise, contact your team
            admin for help.
          </Typography>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            href="/login"
          >
            Back to sign in
          </Button>
        </div>
      </Container>
    </Box>
  );
};

export default EmailInUse;
